import './style.css'
import ReactDOM from 'react-dom/client'
import Experience from './Experience.jsx'
import UI from './UI.jsx'
import { Canvas } from '@react-three/fiber'
import { Suspense } from 'react'
import { Analytics } from "@vercel/analytics/react"
import Wobble from './Wobble.jsx'
import { DSLloader } from './dslLoader.tsx'

const root = ReactDOM.createRoot(document.querySelector('#root'))



root.render(
   <>  

        <Canvas
            className="r3f"
            shadows
            dpr={[1,2]}

            camera={{ 
                position: [ 165, 78, -111 ], 
                fov: 50,
                near: 0.1,
                }}
        >
                <Suspense fallback={null}>
                    
                    <Experience />
                    
                </Suspense>

                <Analytics/>
        
        </Canvas>

        <UI />
        
        <DSLloader />

        <Wobble />

    </>
)


